import React from "react";
import "./SellerLogoutConfirm.css";
import { useNavigate } from "react-router-dom";

export default function SellerLogoutConfirm() {
  const navigate = useNavigate();

  const handleLogout = () => {
     localStorage.removeItem("token");
    localStorage.removeItem("user_token");
    localStorage.removeItem("seller_user");
    localStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <div className="logout-wrapper container">

      <div className="logout-content pt-5">
        <h2 className="logout-title mt-5">
          هل تريد تسجيل الخروج ؟
        </h2>

        <button
          className="logout-main-btn"
          onClick={handleLogout}
        >
          تسجيل الخروج
        </button>

      </div>
    </div>
  );
}
